<template>

    <div class="container middle">

      <div class="image-container">
        <img src="../img/plannerlogo.svg"></img>
      </div>

        <div class="login-header">
          <p>Please login with your Peps account</p>
        </div>

        <div class="inputs">
          <div class="input-container">
            <label>Email:</label>
            <input v-model="email" type="text">
          </div>

          <div class="input-container">
            <label>Password:</label>
            <input v-model="password" type="password">
          </div>

          <button v-on:click="signIn()" class="login-button">Log in</button>
          <div class="forgot-container">
            <label v-on:click="navtoPasswordReset()">Forgot your password?</label>
          </div>

      </div>

        <div class="register-container">
          <label>Don't have an account?</label>
          <button class="register-button" onclick="window.open('https://pepsapp.com/register/', '_blank');">Register</button>
        </div>
      </div>

  </div>

</template>

<script>

  import firebase from 'firebase'

  export default {
    name: 'login',
    title: 'Runner - Login',
    data() {
      return {
        email: '',
        password: '',
      }
    },
    methods: {
      signIn() {
        firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
          (user) => {
            this.$router.replace('myraces')
          },
          (err) => {
            alert(err.message)
          }
        )
      },
      navtoPasswordReset() {
        this.$router.replace('resetPassword')
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import '../styles/styles.scss';

  .container {
    padding: 10%;
    justify-content: flex-start !important;
  }

  .inputs {
    display: flex;
    flex-direction: column;
    //flex: 4;
    justify-content: flex-start;
    margin-top: 10px;
  }

  .inputs .input-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 10px;

    label {
      //padding-left: 7px;
      font-size: $font-medium;
    }

  }

  .forgot-container {

    justify-content: center;
    align-items: center;
    display: flex;

    label {
      color: $cyan;
      text-align: center;
      margin-top: 15px;
      cursor: pointer;
    }
  }


  button {
    width: 100px;
    height: 30px;
    color: white;
    border: none;
    border-radius: 8px;
    align-self: center;
    font-size: $font-semiSemiLarge;
    font-weight: bold;
  }

  .register-container {
    display: flex;
    //flex: 2;
    text-align: center;
    flex-direction: column;

    label {
      margin-top: 20px;
    }
  }

  .register-button {
    background-color: $green;
    margin-top: 10px;
  }

  .login-button {
    background-color: $cyan;
  }

  .login-header {

    text-align: center;

    label {
      font-size: $font-large;
      font-weight: bold;
      margin: 0 0;
      color: $cyan;
      font-family: $opensans;
      font-size: 26px;
    }

    p {
      font-size: $font-semiSemiLarge;
      margin-bottom: 0px;
    }
  }

  .image-container {
    display: flex;
    align-items: center;
    justify-content: center;
    //flex: 1;

    img {
      margin-top:10px;
      width: 110px;
      height: 110px;
    }
  }


  @media screen and (min-width: 1140px) {

    .container.middle {
      padding: 0px 30px 0px 30px;
      width: 400px !important;
      height: 480px !important;
    }

    .login-header {
      margin-top: 50px;
    }

    .image-container {
      img {
        position: absolute;
        top: -55px;
        z-index: 99;
      }
    }

    .register-container {
      justify-content: center;
    }

  }

</style>
